<template>
    <div class="invoice-info">

        <div class="date">
            <h2 v-if="clientNameIs"> {{clientName}} </h2>
            <p v-if="dateIs">Date inssud:<span> {{ date }}</span></p>
            <p v-if="invoiceNumIs">Invoice Num: <span>{{ invoiceNum }}</span></p>
            <p v-for="item in propsLeftCustom" :key="item.value">{{item.name}} {{item.value}}</p>
        </div>

        <div class="client-info">
            <p v-if="sellerNameIs">{{ sellerName }}</p>
            <p v-if="addressIs">{{address}}</p>
            <p v-for="item in propsRightCustom" :key="item.value">{{item.name}} {{item.value}}</p>
        </div>

    </div>
</template>

<script>
    export default ({
        data: () => ({

            "date": "",

        }), methods: {
            setDate() {
                var today = new Date();
                var now = (today.toString()).split(" ")
                return now[2] + " " + now[1] + " " + now[3]
            }
        },

        props: {

            clientName: {},
            dateCustom: {},
            invoiceNum: {},
            sellerName: {},
            clientNameIs: Boolean,
            dateIs: Boolean,
            invoiceNumIs: Boolean,
            sellerNameIs: Boolean,
            address: {},
            addressIs: Boolean,
            propsLeftCustom: {},
            propsRightCustom: {}


        },
        beforeMount() {
            if (this.dateCustom == undefined || this.dateCustom == "" || this.dateCustom == "default")
                this.date = this.setDate()
            else this.date = this.dateCustom
        },
    })
</script>

<style scoped>
    .invoice-info {
        margin: 40px 0 20px 0;
        width: 100%;
        background-color: rgb(230, 225, 225);
        display: flex;
        justify-content: space-between;
        align-items: center;

    }

    .invoice-info .date h2 {
        font-size: 13px;
        color: #222;
        margin-bottom: 10px;
    }

    .invoice-info .date p {
        font-size: 11px;
        font-weight: 600;
        color: #333;
        font-weight: 600;
        margin-bottom: 5px;

    }

    .invoice-info .date p span {
        color: #111;
        font-weight: bold;
        margin-left: 5px;
    }

    .invoice-info .client-info p {
        color: #333;
        font-size: 11px;
        font-weight: 600;
        text-align: right;
        margin-bottom: 5px;
    }

</style>